import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/functions';
// import EventEmitter from "events";
import merge from 'lodash/merge';
import objectPath from "object-path";

// noinspection ES6UnusedImports
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import {FBProfilePrivate, UserData, Profile, FBProfilePublic, FBProfile, ProfilePublic, validforProfit, forProfit, FBProjectPublic, ProjectPublic, FBProjectInternal, FBProjectLikes, FBProject, ProjectPath, Project, validPidValues, ValidPidValues, isValidPidValue, FBProjectStore, ProjectsStore, Projects} from './joto-types';

import * as env from '../env';
import * as log from 'loglevel';

// log.setDefaultLevel(log.levels.DEBUG);
const logger = log.getLogger('joto.ts');
logger.setLevel(env.logLevel);

const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));


/* eslint-disable */

class JotoCallbacksBase {

    userLoginHappened(userData: UserData) {
    }

    userLogoutHappened() {
    }

    profileDataReceived(profiles: ProfilePublic[]) {
    }

    userProfileDataReceived(profile: ProfilePublic) {
    }

    projectDataReceived(projects: Projects) {
    }

    ownProjectDataReceived(projects: Project[]) {
    }

    singleProjectUpdateHappened(project: Project) {
    }
}

/* eslint-enable */

/*
function valueToString(value : string | null) : string {
    return value == null ? '' : value;
}

function normalizeObject(obj : any) : any {
    for(const key in obj) {
        if(obj[key] === null) {
            obj[key] = '';
        }
    }
    return obj;
}

 */


declare global {
    interface Window {
        auth_result: any;
        login_callback: (authResult: any) => void;
    }
}

// Hosting doesn't execute function if function region is not default
// https://github.com/firebase/firebase-tools/issues/842
/*
 * https://firebase.google.com/docs/functions/locations#http_and_client_callable_functions
 * Important: If you are using HTTP functions to serve dynamic content for Firebase Hosting, you must use us-central1.
 */

// https://firebase.google.com/docs/projects/locations#default-cloud-location
const region = 'europe-west1'; // Belgium : https://firebase.google.com/docs/functions/locations, 'europe-west3' would be Frankfurt, but is not available for firebase functions (at least not documented).
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const hostingRegion = 'us-central1'; // Iowa : https://firebase.google.com/docs/functions/locations

class Joto {
    constructor(db: firebase.database.Database, callbacks = new JotoCallbacksBase()) {
        this.db = db;
        this.callbacks = callbacks;
        this.projects = {};
        this.ownProjects = [];
        this.profiles = [];
        this.userData = null;
        this.profile = null;
        this.functions = firebase.app().functions(region);

        // Function URL (sendEmail):  https://us-central1-joto-prekt-dev.cloudfunctions.net/sendEmail
        // Function URL (sendEmail): https://europe-west1-joto-prekt-dev.cloudfunctions.net/sendEmail
        //const functions = firebase.app().functions('europe-west1');
        // const functions = firebase.app().functions();

        this.sendEmailFn = this.functions.httpsCallable('sendEmail');
    }

    db: firebase.database.Database;
    callbacks: JotoCallbacksBase;
    projects: FBProjectStore;
    profiles: FBProfile[];
    userData: UserData | null;
    profile: FBProfile | null;
    ownProjects: Project[];
    functions: firebase.functions.Functions;
    sendEmailFn: firebase.functions.HttpsCallable;

    static getUserDataFromUser(user: firebase.User): UserData {
        const displayName = user.displayName || '';
        const email = user.email || '';
        const emailVerified = user.emailVerified;
        const photoURL = user.photoURL || '';
        const isAnonymous = user.isAnonymous;
        const uid = user.uid || '';
        const providerData = user.providerData;
        return {displayName, email, emailVerified, photoURL, isAnonymous, uid, providerData};
    }

    displayGuiLogin(parentWindow: Window) {
        parentWindow.auth_result = null;

        /*
         * https://github.com/firebase/firebaseui-web#available-callbacks
         * The AuthResult of successful sign-in operation. The AuthResult object has same signature as firebase.auth.UserCredential.
         * https://firebase.google.com/docs/reference/js/firebase.auth.html#usercredential
         */
        parentWindow.login_callback = (authResult: any) => {
            parentWindow.auth_result = authResult;
            const user = authResult.user as firebase.User;

            // const providerData = user.providerData;
            const userData = Joto.getUserDataFromUser(user);

            this.callbacks.userLoginHappened(userData);
            // XXX
            parentWindow.location.reload();
            // this.readProfileAndOwnProjectsAfterLogin();
            // this.readProfile(userData);
        };

        parentWindow.open('/firebaseauth.html', 'Sign In', 'width=985,height=735');

    }

    logout() {
        (async () => {
            const wasLoggedIn : boolean = (this.userData != null);
            try {
                await firebase.auth().signOut();
            } catch(e) {
                logger.warn('Problem during logout : ' + e);
            }
            this.userData = null;
            this.callbacks.userLogoutHappened();
            if(wasLoggedIn)
                window.location.reload();
        })();
    }

    async readProjects(): Promise<FBProjectStore> {
        logger.debug('Joto.readProjects() start');
        this.projects = (await this.db.ref("projects").once('value')).val();
        let ownUid = null;
        if(this.userData)
            ownUid = this.userData.uid;
        this.callbacks.projectDataReceived(Joto.extractProjectData(this.projects, ownUid));
        logger.debug(JSON.stringify(this.projects, null, 2));
        logger.debug('Joto.readProjects() return');
        return this.projects;
    }

    async readProject({uid, pid}: { uid: string, pid: ValidPidValues }) : Promise<Project | null> {
        const path : string = `projects/${uid}/${pid}`;
        logger.debug(`Joto.readProject(${JSON.stringify({uid, pid})}) start : ${path}`);
        const project = (await this.db.ref(path).once('value')).val() as FBProject;
        // noinspection UnnecessaryLocalVariableJS
        const p = Joto.FBProjectToProject(project, uid, pid,null);
        return p;
    }

    async readProfile(userData: UserData): Promise<FBProfile> {
        let uid = userData.uid;
        // get profile
        let path = "profiles/" + uid + '/public';
        logger.debug('readProfile() : going to read path : "' + path + '"');
        let publicProfile = (await this.db.ref(path).once('value')).val();
        logger.debug('readProfile() : successfully read path : "' + path + '"');

        // if profile does not exist create one
        if (!publicProfile) {
            publicProfile = {
                uid: userData.uid,
                name: userData.displayName,
                nick: '',
                description: ''
            };
            await this.db.ref("profiles/" + uid + '/public').set(publicProfile);

            // read the value from the database to make sure that values are in sync
            publicProfile = (await this.db.ref("profiles/" + uid + '/public').once('value')).val();
        }
        logger.debug('Got public profile : "profiles/' + uid + '/public" : ' + JSON.stringify(publicProfile));

        const {name = '', nick = '', description = ''} = publicProfile;
        const localPublicProfile: FBProfilePublic = {uid, name, nick, description};
        try {
            this.callbacks.userProfileDataReceived(localPublicProfile);
        } catch (e) {
            logger.error('this.callbacks.userProfileDataReceived() received an exception : ' + e);
        }

        path = "profiles/" + uid + '/private';
        //logger.debug('readProfile() : going to read path : "' + path + '"');
        try {
            //let privateProfile = (await this.db.ref(path).once('value')).val();
            //logger.debug('readProfile() : successfully read path : "' + path + '"');
            const localPrivateProfile: FBProfilePrivate = (({email, emailVerified, photoURL, isAnonymous}) => ({
                email,
                emailVerified,
                photoURL,
                isAnonymous
            }))(userData);
            this.profile = {public: localPublicProfile, private: localPrivateProfile};

            // noinspection PointlessBooleanExpressionJS
            if (true) { // !privateProfile
                // https://lh5.googleusercontent.com/-AUNQdgjwn8s/AAAAAAAAAAI/AAAAAAAAAAA/ACHi3reoAGM-5p5t8Agknu7SOblHj-0XgQ/photo.jpg

                logger.debug('trying to write private profile data : "' + path + '" : ' + JSON.stringify(localPrivateProfile));
                await this.db.ref(path).set(localPrivateProfile);
                logger.debug('wrote private profile data : "' + path + '" : ' + JSON.stringify(localPrivateProfile));
            }

            return this.profile;
        } catch (e) {
            logger.error('readProfile() : error while reading path : "' + path + '" : ' + JSON.stringify(e));
            throw e;
        }
    }

    static FBProjectToProject(inp : FBProject, pUid: string, pPid: ValidPidValues, ownUid : string | null) : Project | null {
        if (inp.public != null) {
            let ownLike : boolean = (ownUid === pUid);
            let likeCount = 0;
            if (inp.likes) {
                if (ownUid) {
                    const v = inp.likes[ownUid];
                    if(typeof v !== 'undefined')
                        ownLike = v;
                }
                // likeCount = Object.keys(inp.likes).length;
                likeCount = Object.values(inp.likes).filter(Boolean).length
            }

            // noinspection UnnecessaryLocalVariableJS
            let p: Project = {
                creationTimestamp: 0,
                modificationTimestamp: 0, ...(inp.public), ...(inp.internal),
                uid: pUid,
                pid: pPid,
                like: ownLike,
                likeCount
            };
            return p;
        }
        return null;
    }

    // https://github.com/Microsoft/TypeScript/issues/3500
    static extractProjectData(projects: FBProjectStore, ownUid: string | null): Projects {
        let r1: Project[] = [];
        for (const uid in projects) {
            if (!projects.hasOwnProperty(uid))
                continue;
            const userProjects = projects[uid];
            if (userProjects != null) {
                let pid: keyof typeof userProjects;
                for (pid in userProjects) {
                    if(!userProjects.hasOwnProperty(pid) || !isValidPidValue(pid)) continue;
                    const userProject = userProjects[pid];
                    if (userProject != null) {
                        const p = Joto.FBProjectToProject(userProject, uid, pid, ownUid);
                        if(p)
                            r1.push(p);
                    }
                }
            }
        }
        r1.sort((a, b) => a.creationTimestamp - b.creationTimestamp);

        let store : ProjectsStore = {};
        for(const p of r1) {
            const toMerge : ProjectsStore = {[p.uid]: {[p.pid]: p}};
            store = merge(store, toMerge);
        }
        const projectPath : ProjectPath[] = [];
        for(const p of r1) {
            const path : ProjectPath = {
                uid : p.uid,
                pid : p.pid
            };
            projectPath.push(path);
        }

        // noinspection UnnecessaryLocalVariableJS
        const r : Projects = {
            store: store,
            projectPathList: projectPath
        };

        return r;
    }

    extractOwnProjectData(userData: UserData, projects: FBProjectStore): Project[] {
        let r: Project[] = [];
        const uid = userData.uid;
        const userProjects = projects[uid];
        if (userProjects != null) {
            for (const pid in userProjects) {
                if (isValidPidValue(pid)) {
                    const userProject = userProjects[pid];
                    if (userProject != null) {
                        const p = Joto.FBProjectToProject(userProject, uid, pid, uid);
                        if(p)
                            r.push(p);
                    }
                }
            }
        }
        r.sort((a, b) => a.pid < b.pid ? -1 : 1);
        this.ownProjects = r;
        return r;
    }

    notifyAboutOwnProjectDataReceived() {
        this.callbacks.ownProjectDataReceived(this.ownProjects);
    }

    async login() : Promise<[Promise<UserData | null> | null, Promise<FBProjectStore>]> {
        const p1 : Promise<FBProjectStore>  = this.readProjects();
        const p2 : Promise<UserData | null> = new Promise<UserData | null>((resolve, reject) => {
            const unsubscribe = firebase.auth().onAuthStateChanged(async authData => {
                unsubscribe();
                try {
                    if (authData) {
                        logger.info("User " + authData.uid + " is logged in.");// + JSON.stringify(authData.providerData)
                    } else {
                        logger.info("User is logged out");
                    }
                    const user = firebase.auth().currentUser;
                    if (user) {
                        const userData = Joto.getUserDataFromUser(user);
                        this.userData = userData;
                        this.callbacks.userLoginHappened(userData);

                        await this.readProfile(userData);
                        resolve(userData);
                    } else {
                        this.logout();
                        resolve(null);
                    }
                } catch (e) {
                    logger.error('error during login process : ' + JSON.stringify(e));
                    this.logout();
                    reject(e);
                }
            });
        });

        (async () => {
            await Promise.all([p1, p2]); // make sure that project data is read and login has happened and only then notify about own project data available
            const userData = await p2;
            const projects = await p1;
            if (userData != null) {
                this.extractOwnProjectData(userData, projects);
                this.notifyAboutOwnProjectDataReceived();
            }
        })();

        return [p2,p1];
    }

    async readProfiles() : Promise<FBProfilePublic[]> {
        let profileKeys = (await this.db.ref("profileKeys").once('value')).val();
        let result : FBProfilePublic[] = [];
        for(let key in profileKeys) {
            let profile = (await this.db.ref("profiles/" + key + '/public').once('value')).val() as FBProfilePublic;
            result.push(profile);
        }
        this.callbacks.profileDataReceived(result);
        return result;
    }

    async createOrUpdateProfile({name, nick, description} : Profile) : Promise<FBProfilePublic> {
        if(!this.userData)
            throw new Error('You do not have a valid userData object and cannot interact with the backend. You need to login first.');
        const uid = this.userData.uid;
        const p1 = this.db.ref("profiles/" + uid + '/public').update({uid, name, nick, description});
        const p2 = this.db.ref("profileKeys/" + uid).set(true);
        await Promise.all([p1, p2]);
        const profiles = await this.readProfiles();
        const r = profiles.find(p => p.uid === uid);
        if(r == null)
            throw new Error('Something went wrong during createOrUpdateProfile(). Could not read back the profile.');
        return r;
    }


    static formatId(id : string | number) : ValidPidValues {
        let sid = '' + id;
        id = parseInt(sid);
        sid = '' + id;
        sid = sid.padStart(2, '0');
        if(!isValidPidValue(sid))
            throw new Error('Could not generate a valid pid');
        return sid;
    }

    async readOwnProjectAsFBProject(id : string | number) : Promise<(FBProject | null)> {
        if(this.userData == null)
            throw new Error('You tried to read the project with id : "' + id + '", but you do not seem to be logged in!');
        const uid = this.userData.uid;
        const sid = Joto.formatId(id);
        return (await this.db.ref("projects/" + uid + '/' + sid).once('value')).val() as (FBProject | null);
    }

    async deleteProject(id : string | number) : Promise<null | FBProject> {
        if(this.userData == null)
            throw new Error('You tried to write the project with id : "' + id + '", but you do not seem to be logged in!');

        const uid = this.userData.uid;
        const sid = Joto.formatId(id);

        const path = "projects/" + uid + '/' + sid + '/public';
        logger.debug('trying to delete project data : "' + path + '"');
        await this.db.ref(path).set(null);
        logger.debug('wrote project data : "' + path + '"');
        const r = await this.readOwnProjectAsFBProject(id);
        if(r != null && r.public != null)
            throw new Error(`Something went wrong while deleting the project ${uid} ${sid}`);

        await sleep(400);

        const projects = await this.readProjects();
        this.extractOwnProjectData(this.userData, projects);
        await this.notifyAboutOwnProjectDataReceived();

        return r;
    }

    async writeProject(id : string | number, project : FBProjectPublic) : Promise<FBProject> {
        if(this.userData == null)
            throw new Error('You tried to write the project with id : "' + id + '", but you do not seem to be logged in!');

        const uid = this.userData.uid;
        const sid = Joto.formatId(id);
        const dataToWrite : FBProjectPublic =  (({name, abstract, description, pictureURL, discussionURL, forProfit, zip_code, city, state}) => ({name, abstract, description, pictureURL, discussionURL, forProfit, zip_code, city, state}))(project);
        const path = "projects/" + uid + '/' + sid + '/public';
        logger.debug('trying to write project data : "' + path + '" : ' + JSON.stringify(dataToWrite));
        await this.db.ref(path).set(dataToWrite);
        logger.debug('wrote project data : "' + path + '" : ' + JSON.stringify(dataToWrite));
        const r = await this.readOwnProjectAsFBProject(id);
        logger.debug('returning re-read project data : "' + path + '" : ' + JSON.stringify(r));
        if(r == null)
            throw new Error(`Something went wrong while writing the project ${uid} ${sid} : ${JSON.stringify(project)}`);

        await sleep(400);

        const projects = await this.readProjects();
        this.extractOwnProjectData(this.userData, projects);
        await this.notifyAboutOwnProjectDataReceived();

        return r;
    }

    async createProject(project : FBProjectPublic) : Promise<FBProject> {
        if(this.userData == null)
            throw new Error('You tried to create a project, but you do not seem to be logged in!');

        const uid = this.userData.uid;
        const userProjects = this.projects[uid];
        let pid = '00';
        if(userProjects != null) {
            const pidKeys = Object.keys(userProjects);
            if(Array.isArray(pidKeys) && pidKeys.length > 0) {
                pidKeys.sort();

                let lastPidKey = "-1";
                for(const lpid of pidKeys) {
                    if(!isValidPidValue(lpid))
                        continue;
                    const userProject = userProjects[lpid];
                    if ((userProject != null) && (userProject.public != null)) {
                        lastPidKey = lpid;
                    }
                }
                const lastPidKeyInt = parseInt(lastPidKey);
                const pidInt = lastPidKeyInt + 1;
                pid = Joto.formatId(pidInt);
            }
        }
        logger.debug('pid would be : ' + pid);

        return this.writeProject(pid, project);
    }

    async registerLike(path : ProjectPath, ownUid : string, value : boolean) : Promise<boolean> {
        const fbpath = "projects/" + path.uid + '/' + path.pid + '/likes/' + ownUid;
        logger.debug('trying to write project data : "' + fbpath + '" : ' + value);
        await this.db.ref(fbpath).set(value);

        const read_back_vaue = (await this.db.ref(fbpath).once('value')).val() as (boolean | null);
        if(read_back_vaue == null)
            throw new Error(`Could not read back like value : ${fbpath}`);

        if(read_back_vaue !== value)
            throw new Error(`Read back like value  from : ${fbpath} : ${read_back_vaue} differs from write value : ${value}`);

        return read_back_vaue;
    }

    async like(path : ProjectPath, value : boolean) {
        if(!this.userData)
            throw new Error(`You can only like projects when you're logged in: ${path}.`);

        const p = objectPath.get(this.projects, [path.uid, path.pid]) as FBProject | null;
        if(!p)
            throw new Error(`While trying to like project: ${path} the project could not be found.`);


        if(!p.likes)
            p.likes = {};

        p.likes[this.userData.uid] = value;

        await this.registerLike(path, this.userData.uid, value);

        const r = Joto.FBProjectToProject(p, path.uid, path.pid, this.userData.uid);
        if(r)
            this.callbacks.singleProjectUpdateHappened(r);
        else
            throw new Error(`While trying to like project the conversion FBProjectToProject failed: ${path}.`);
    }

    // Function URL (sendEmail):  https://us-central1-joto-prekt-dev.cloudfunctions.net/sendEmail
    // Function URL (sendEmail): https://europe-west1-joto-prekt-dev.cloudfunctions.net/sendEmail
    //const functions = firebase.app().functions('europe-west1');
    // const functions = firebase.app().functions();

    async sendEmail(frm: string, toUid: string | string[], subject: string, text: string) : Promise<void> {
        // const data = {
        //     frm: 'me@abc.com',
        //     to: 'christian.schuhegger@gmail.com',
        //     subject: 'Mailgun API test from firebase!',
        //     text: 'Test content from firebase.'
        // }
        const data = {frm, toUid, subject, text};
        let result;
        try {
            result = await this.sendEmailFn(data);
            logger.debug('result of sendEmail: ' + JSON.stringify(result, null, 2));
        } catch(e) {
            logger.error('error from sendEmail : ' + JSON.stringify(e));
        }
        return;
    }

    async getPublicProfile(uid : string) : Promise<FBProfilePublic | null> {
        const path = "profiles/" + uid + '/public';
        logger.debug('getPublicProfile() : going to read path : "' + path + '"');
        const publicProfile = (await this.db.ref(path).once('value')).val() as FBProfilePublic | null;
        logger.debug('getPublicProfile() : successfully read path : "' + path + '"');
        logger.info('Got public profile : "profiles/' + uid + '/public" : ' + JSON.stringify(publicProfile));
        return publicProfile;
    }
}

export function projectArrayFromStoreAndPathArray(store : ProjectsStore, paths : ProjectPath[]) : Project[] {
    const projects : Project[] = [];
    for(const path of paths) {
        const p : Project = objectPath.get(store, [path.uid, path.pid]);
        if(p == null)
            continue;
        projects.push(p);
    }
    return projects;
}

export function projectFromStoreAndPath(store : ProjectsStore, path : ProjectPath) : Project | null {
    // noinspection UnnecessaryLocalVariableJS
    const p : Project = objectPath.get(store, [path.uid, path.pid]);
    return p;
}

export {JotoCallbacksBase, Joto};
export default Joto;

